/**
 * Handles CoralRequests, producing observable CoralResponses.
 *
 * Based on Angular's HttpHandler interface. While this class is fully
 * framework-agnostic, the Angular documenation may be useful for understanding
 * how handlers are used.
 */
export class CoralHandler {
}
